import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import Page from '../pages';
import store from '../../vendors/redux/store';
import {Provider} from 'react-redux';

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Page/>
      </Provider>
    </BrowserRouter>
  );
};

export default Routes;
